export default __webpack_public_path__ + "static/py-071e1fd0fcd266b47192b602e1fa5e0d.svg";